module.exports = __webpack_public_path__ + "static/media/10.4baa1c40.jpg";